import { SkeletonLine } from '@insurancemenu/imenu-components-lib';
import { InfoButtonFilled } from '@insurancemenu/imenu-components-lib/dist/icons';
import { colors, typography } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled, { css, CSSProp } from 'styled-components';

/** Approximate chip height derived from product line chip font-size and line-height. */
export const PRODUCT_LINE_CHIP_HEIGHT = '3.4rem';

export const ProductLineItemStyled = styled.li<{ $unavailable?: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  ${typography.regular[16]};
  padding: 0.5rem 1.5rem;
  border-radius: 5px;
  box-shadow: 0 0 0 1px ${colors.neutral[300]};
  ${({ $unavailable = false }): CSSProp =>
    $unavailable &&
    css`
      opacity: 0.5;
      background-color: ${colors.neutral[100]};
    `}
`;

export const ProductLinesListStyled = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ProductLinesSkeletonListStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  min-height: ${PRODUCT_LINE_CHIP_HEIGHT};
`;

export const ProductLineSkeletonStyled = styled(SkeletonLine)`
  border-radius: 5px;
  flex-shrink: 0;
`;

export const ProductLinesHintStyled = styled.div`
  ${typography.regular[16]};
  color: ${colors.neutral[700]};
  margin: 0;
  min-height: 8rem;
  display: inline-flex;
`;

export const IconStyled = styled(InfoButtonFilled)`
  margin-right: 0.5rem;
`;

export const UnavailableSectionTitleStyled = styled.h3`
  width: 100%;
  ${typography.regular[14]};
  color: ${colors.neutral[700]};
  text-transform: uppercase;
  display: flex;
  gap: 1rem;
  align-items: center;
  margin: 0;
  border-bottom: 0.1rem solid ${colors.neutral[300]};
  margin-top: 3rem;
  padding-bottom: 1rem;
`;
